// This file is automatically generated. DO NOT EDIT.

import { getCoreURL, toSnakeKeys } from '@api/internal';

export interface PostCreateRequest {
  region: 'eu' | 'us';
  /** Vote key */
  voteKey: string;
  /** Rating sumbited by voter */
  rating: 1 | 2 | 3 | 4 | 5;
  /** Version of the experiment */
  version?:
    | 'stars_only'
    | 'stars_and_structured_feedback'
    | 'stars_and_unstructured_feedback';
  /** Feedback submitted by voter */
  feedback?: string;
}

export function postCreateRequest(requestParams: PostCreateRequest): Request {
  const data = {
    rating: toSnakeKeys(requestParams.rating),
    version: toSnakeKeys(requestParams.version),
    feedback: toSnakeKeys(requestParams.feedback),
  };

  const coreURL = getCoreURL(requestParams.region);
  const url = `${coreURL}/participant-rating/create/${requestParams.voteKey}`;
  return new Request(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
}
